import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify, useStore } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { errorMessages } from "app";
import CreateForm from "./CreateForm";

const STORE_KEY = "trainingBase.filters";

const CreateInternshipSessions = () => {
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  const transform = data => {
    const { structuralUnitId, ...rest } = data;

    return rest;
  };

  return (
    <>
      <Create
        title="Създаване на учебна база"
        actions={<BackButtonToolbar />}
        transform={transform}
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            academicYearId: filters?.academicYearId,
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
          }}
        >
          <CreateForm filters={filters} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateInternshipSessions;
